import { TramitacioTaskNode } from "./tramitacio-task-node";

export class TramitacioTaskDocumentComptableEcofinNode extends TramitacioTaskNode {

}
